export default "__VITE_ASSET__fbe6b173__"